import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ApsServiceService } from '../aps-service.service';

@Component({
  selector: 'app-advisory-board',
  templateUrl: './advisory-board.component.html',
  styleUrls: ['./advisory-board.component.css']
})
export class AdvisoryBoardComponent implements OnInit {
  constructor(private searchitem: ApsServiceService,private toastr: ToastrService) { }
  loaderdata:any=false
  admember:any
  boardmember:any
  ngOnInit(): void {
    this.loaderdata=true
    this.getAdmember();
    this.getboardmember()
  }
 validateEmails = (email) => {

    return email.toLowerCase().match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    
  };


  onClickSubmit(data){
    //console.log(data)
    //console.log(data.value)
    //console.log(data.value['email'])
    var dataset=data.value
   
    if(!dataset['name'] || dataset['name']=="" || !dataset['location'] || dataset['location']=="" || !dataset['message'] || dataset['message']=="" || !dataset['name'] || dataset['name']=="" || !dataset['name'] || dataset['name']==""  ){
      //console.log("hii")
      this.toastr.warning('Some fields are missing ', 'Oops!..')
    }else{
    //console.log(this.validateEmails(data.value["email"]))
    if(this.validateEmails(dataset["email"])){


    this.searchitem.ContactResponce(data.value).subscribe((responce) => {
      if(responce.status){
  
        this.toastr.success(responce.msg)
        setTimeout(function(){
          location.reload()
       }, 4000);
      }else{
        this.toastr.warning('Oops! Something went wrong, please try again later', 'Oops!..')
      }
    })
  }else{
    this.toastr.warning('Incorrect Email Format', 'Oops!..')
  }
  }
}
getAdmember(){
 
  this.searchitem.getadvisorymember().subscribe((responce) => {
    if(responce.status){
      //console.log(responce.datas)
      this.admember=responce.datas
      this.loaderdata=false
    }else{
      this.loaderdata=false
    }
  });
}
getboardmember(){
  this.searchitem.getboard().subscribe((responce) => {
    if(responce.status){
      //console.log(responce.datas)
      this.boardmember=responce.datas
      this.loaderdata=false
    }else{
      this.loaderdata=false
    }
  });
}


}
